import React from 'react';
import { Box, Spinner, VStack } from '@chakra-ui/react';

export const PartnerSignInPage: React.FC = () => {
  return (
    <VStack spacing={4} align="center" justify="center" minH="100vh">
      <Box>
        <Spinner size="xl" />
      </Box>
      <Box>Completing sign in...</Box>
    </VStack>
  );
};
